import { render, staticRenderFns } from "./chartererDetails.vue?vue&type=template&id=481779fa&scoped=true"
import script from "./chartererDetails.vue?vue&type=script&lang=js"
export * from "./chartererDetails.vue?vue&type=script&lang=js"
import style0 from "./chartererDetails.vue?vue&type=style&index=0&id=481779fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481779fa",
  null
  
)

export default component.exports